'use client';

import { useQuery, useQueryClient } from '@tanstack/react-query';
import { getUserTeamsAction } from '@/dal/teams/actions';

export function useTeam() {
  const queryClient = useQueryClient();
  const { data, error, isLoading } = useQuery({
    queryKey: ['teams'],
    queryFn: getUserTeamsAction,
  });

  const mutate = () => queryClient.invalidateQueries({ queryKey: ['teams'] });

  return {
    teams: data,
    isLoading,
    error,
    mutate,
  };
}
